const changeLog = [
  {
    version: "05.11.04",
    issues: [
      {id: "", description: "Modified previous bug fix with better handling to stop duplication bug."}
    ]
  }
];

export default changeLog;
